// @flow

import { cmsAxios } from '../axios-config';

const getNotifications = () => {
  return cmsAxios.get('/notifications?_sort=created_at:DESC&_limit=10');
};

export default getNotifications;
